module.exports = __webpack_public_path__ + "img/icon_pedbot_cinza.7465c840.svg";